import { WINELIDAYS_LS_PREFIX } from '@/constants/localStorage';
import { safeWarn } from '@/utils/safeLog';
const AVAILABILITY_FILTERS_LS_KEY = `${WINELIDAYS_LS_PREFIX}.af`;
export const reconcileLocalFilters = (initialFilters) => {
    const localFilters = localStorage.getItem(AVAILABILITY_FILTERS_LS_KEY);
    if (localFilters) {
        try {
            const decodedFilters = Buffer.from(localFilters, 'base64').toString();
            const parsedFilters = JSON.parse(decodedFilters);
            let newStartDate = null;
            if (parsedFilters.date.startDate) {
                newStartDate = new Date(parsedFilters.date.startDate);
                if (+newStartDate > Date.now()) {
                    parsedFilters.date.startDate = newStartDate;
                }
                else {
                    parsedFilters.date.startDate = null;
                }
            }
            if (parsedFilters.date.startDate && parsedFilters.date.endDate) {
                const newEndDate = new Date(parsedFilters.date.endDate);
                if (+newEndDate > Date.now() && +newEndDate > +parsedFilters.date.startDate) {
                    parsedFilters.date.endDate = newEndDate;
                }
                else {
                    parsedFilters.date.endDate = null;
                }
            }
            else {
                parsedFilters.date.endDate = null;
            }
            return {
                ...initialFilters,
                ...parsedFilters
            };
        }
        catch (e) {
            safeWarn('could not parse stored state', e);
        }
    }
    return initialFilters;
};
export const storeLocalFilters = (filters) => {
    localStorage.setItem(AVAILABILITY_FILTERS_LS_KEY, Buffer.from(JSON.stringify(filters)).toString('base64'));
};
export const resetLocalFilters = () => {
    localStorage.removeItem(AVAILABILITY_FILTERS_LS_KEY);
};
